import { Row, Col, Card, Avatar } from "antd";
import { motion } from "motion/react";
import { Award, BookOpen } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

const doctors = [
  {
    name: "Dr. Aarav Sharma",
    qual: "MD (Ayurveda), BAMS",
    spec: "Panchakarma Specialist",
    bio: "Over 15 years of experience in deep detoxification and traditional pulse diagnosis.",
    img: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=2070&auto=format&fit=crop",
  },
  {
    name: "Dr. Meera Patel",  
    qual: "MS (Ayurveda), Ph.D.",
    spec: "Women's Health & Wellness",
    bio: "Specializes in holistic hormonal balance, fertility, and postpartum care.",
    img: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=2070&auto=format&fit=crop",
  },
  {
    name: "Dr. Rohan Verma",
    qual: "Dip. in Ayurvedic Med.",
    spec: "Holistic Wellness",
    bio: "Expert in lifestyle counseling, nutrition, and stress management therapies.",
    img: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=1964&auto=format&fit=crop",
  },
  {
    name: "Dr. Priya Desai",
    qual: "Ph.D. (Dravyaguna)",
    spec: "Herbal Medicine & Skin Care",
    bio: "Renowned for developing customized herbal formulations for complex skin conditions.",
    img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=2070&auto=format&fit=crop",
  },
];

export default function OurTeam() {
  return (
    <section className="py-24 bg-brand-beige border-b border-brand-lightgold overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease }}
          className="mb-16 text-center max-w-2xl mx-auto"
        >
          <h2 className="uppercase md:text-xl text-base font-extrabold text-brand-gold mb-6 inline-block">
            Our Experts
          </h2>
          <h3 className="text-4xl font-bold text-brand-forest mb-4">Meet Our Ayurvedic Doctors</h3>
          <p className="text-gray-600">
            Our team of experienced doctors brings together centuries of traditional Ayurvedic wisdom dedicated to
            your holistic well-being.
          </p>
        </motion.div>

        <Row gutter={[24, 24]}>
          {doctors.map((doc, idx) => (
            <Col xs={24} md={12} lg={6} key={idx}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, ease, delay: idx * 0.08 }}
                whileHover={{ y: -5 }}
                className="h-full"
              >
                <Card className="!rounded-2xl !border-brand-lightgold !text-center !shadow-sm hover:!shadow-xl !transition-all !duration-300 h-full flex flex-col items-center">
                  {/* <Avatar
                    size={96}
                    src={doc.img}
                    className="!border-4 !border-brand-beige !shadow-inner mb-6"
                  /> */}
                  <h4 className="font-bold text-xl text-brand-forest mb-1">{doc.name}</h4>
                  <p className="text-[11px] font-bold uppercase tracking-widest text-brand-gold mb-4">{doc.spec}</p>
                  <p className="text-sm text-gray-500 mb-6 leading-relaxed">{doc.bio}</p>

                  <div className="w-full pt-4 border-t border-brand-lightgold flex flex-col gap-2 text-left">
                    <div className="flex items-center gap-2 text-[11px] font-medium text-gray-600">
                      <Award className="w-4 h-4 text-brand-gold" />
                      <span className="truncate">{doc.qual}</span>
                    </div>
                    <div className="flex items-center gap-2 text-[11px] font-medium text-gray-600">
                      <BookOpen className="w-4 h-4 text-brand-gold" />
                      <span className="truncate">{doc.spec}</span>
                    </div>
                  </div>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}
